import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
    Shield,
    Plug,
    Monitor,
    Menu,
    X,
    Cog,
    Building2,
} from "lucide-react";
import { Button } from "../../components/ui/button";


const SettingsLayout = () => {

    const is_admin = sessionStorage.getItem('is_admin') === 'true';
    const is_super_admin = sessionStorage.getItem('is_super_admin') === 'true';

    const tabs = [
        { name: "Appearance", icon: Monitor, route: "/settings/appearance", },
        ...(is_admin || is_super_admin ? [
            { name: "Organization", icon: Building2, route: "/settings/organization-edit", },
            { name: "Branch", icon: Building2, route: "/settings/branch", },
            { name: "Integrations", icon: Plug, route: "/settings/integrations", },
            { name: "Configuration", icon: Cog, route: "/settings/configuration", },
        ] : []),
        { name: "Security & Access", icon: Shield, route: "/settings/security", },
    ];

    const visibleTabs = tabs;
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-[calc(100vh-100px)] gap-3">
            {/* Mobile Hamburger (only show when sidebar is closed) */}
            {!sidebarOpen && (
                <Button
                    className="fixed top-2 left-16 md:hidden z-40 p-2 h-10 w-10 rounded-lg transition-all ease-in-out delay-300"
                    onClick={() => setSidebarOpen(true)}
                >
                    <Menu size={20} />
                </Button>
            )}


            {/* Sidebar */}
            <aside
                className={`fixed z-40 md:z-0 md:static top-0 left-0 h-full w-64 rounded-md bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 p-4 transform transition-transform duration-300 
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 overflow-y-auto`}
            >
                {/* Close button (mobile only) */}
                <div className="flex justify-between items-center mb-4 md:hidden">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                        Settings
                    </h2>
                    <button onClick={() => setSidebarOpen(false)}>
                        <X size={20} className="text-gray-600 dark:text-gray-300" />
                    </button>
                </div>

                <h2 className="hidden md:block text-lg font-semibold mb-4 text-gray-800 dark:text-gray-200">
                    Settings
                </h2>

                <nav className="flex flex-col gap-2">
                    {visibleTabs.map((tab) => (
                        <NavLink
                            key={tab.route}
                            to={tab.route}
                            onClick={() => setSidebarOpen(false)} // auto close on mobile
                            className={({ isActive }) =>
                                `flex items-center gap-2 px-3 py-2 rounded-md transition-colors ${isActive
                                    ? "bg-sidebar/10 text-sidebar-primary font-medium dark:bg-sidebar-primary/20 dark:text-sidebar-primary"
                                    : "text-gray-600 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700"
                                }`
                            }
                        >
                            <tab.icon size={18} />
                            {tab.name}
                        </NavLink>
                    ))}
                </nav>
            </aside>

            {/* Main content */}
            <main className="flex-1 p-6 overflow-y-auto text-gray-900 dark:text-gray-100 dark:bg-gray-900 bg-gray-50 rounded-md">
                <Outlet />
            </main>
        </div>
    );
};

export default SettingsLayout;